export default {
  EGST_REGULAR: 'regular',
  EGST_BONUS_GAME: 'bonus_game',
  EGST_FREESPINS_GAME: 'freespin_game',
  EGST_JACKPOT_GAME: 'jackpot_game',
  EGST_MYSTERY_BONUS_GAME: 'mystery_bonus_game'
}
